import { render } from "./YPLoading.vue?vue&type=template&id=320dce19&scoped=true"
import script from "./YPLoading.vue?vue&type=script&lang=js"
export * from "./YPLoading.vue?vue&type=script&lang=js"

import "./YPLoading.vue?vue&type=style&index=0&id=320dce19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320dce19"]])

export default __exports__